import { CUDO_TRAVEL, TREATME_TRAVEL, DEALS_TRAVEL, SCOOPON_TRAVEL } from 'constants/brands'
import config from 'constants/config'
import { reportClientError } from 'services/errorReportingService'

export function getBrandLabel(brand: string) {
  switch (brand) {
    case CUDO_TRAVEL: return 'cudo'
    case TREATME_TRAVEL: return 'treatme'
    case DEALS_TRAVEL: return 'deals'
    case SCOOPON_TRAVEL: return 'scoopon'
    default: return null
  }
}

export function isWhitelabelBrand(brand: string) {
  const label = getBrandLabel(brand)
  return label ? label.length > 0 : false
}

export type WhiteLabelAppConfig = {
  isApp: boolean
  googleLoginURI?: string
  clientVersion?: string
  platform?: 'ios' | 'android'
  isAndroid?: boolean
  isIOS?: boolean
  appName?: string
}

export function getWhiteLabelAppConfig(): WhiteLabelAppConfig {
  return {
    isApp: !!window.whiteLabelAppConfig,
    platform: window.whiteLabelAppConfig?.plataform,
    googleLoginURI: window.whiteLabelAppConfig?.googleLoginURI,
    clientVersion: window.whiteLabelAppConfig?.clientVersion,
    isAndroid: window.whiteLabelAppConfig?.plataform === 'android',
    isIOS: window.whiteLabelAppConfig?.plataform === 'ios',
    appName: window.whiteLabelAppConfig?.appName,
  }
}

export function postMessageToWhiteLabelApp(payload: unknown) {
  try {
    window.ReactNativeWebView?.postMessage(JSON.stringify(payload))
  } catch(error) {
    reportClientError(error, { function: 'postMessageToWhiteLabelApp', brand: config.BRAND, payload })
    console.error('Error posting message to white label app', error)
  }
}
